import React from 'react';

const scales = [
  {
    name: 'CURB-65',
    href: 'https://curb65.com.br/',
    description: 'Avaliação de gravidade em pneumonia adquirida na comunidade; inclui confusão como um dos critérios.',
    context: 'Útil quando pneumonia e alteração do estado mental aparecem no mesmo atendimento.',
  },
  {
    name: 'Critérios de Wells',
    href: 'https://calculadorawells.com.br/',
    description: 'Estratificação de probabilidade clínica para tromboembolismo venoso.',
    context: 'Ferramenta paralela quando o quadro clínico exige avaliação de TEP/TVP.',
  },
  {
    name: 'HEART Score',
    href: 'https://escoreheart.com.br/',
    description: 'Estratificação de risco em pacientes com dor torácica no contexto de síndrome coronariana aguda.',
    context: 'Complementa, mas não substitui, avaliação neurológica quando há alteração de consciência.',
  },
  {
    name: 'Escore de Alvarado',
    href: 'https://escorealvarado.com.br/',
    description: 'Ferramenta de apoio à avaliação clínica de suspeita de apendicite aguda.',
    context: 'Exemplo de escore específico de doença, diferente da avaliação neurológica da ECG.',
  },
  {
    name: 'FOUR Score',
    href: null,
    description: 'Escala neurológica que inclui respostas ocular e motora, reflexos de tronco e padrão respiratório, sem componente verbal.',
    context: 'Pode ser considerada em pacientes intubados e cenários de terapia intensiva.',
  },
  {
    name: 'AVDI (AVPU)',
    href: null,
    description: 'Esquema de triagem rápida em quatro categorias: Alerta, resposta Verbal, resposta à Dor (pressão) e Inconsciente. Em inglês: Alert, Voice, Pain, Unresponsive.',
    context: 'Não é predecessora nem versão simplificada da ECG; é uma ferramenta paralela de triagem rápida. A correspondência com a ECG é aproximada e não substitui O, V e M.',
  },
];

const RelatedScales = () => (
  <section className="rel-section">
    <span className="h2__n mono">ESCALAS RELACIONADAS</span>
    <h2 className="h2">Quais escalas complementam a Escala de Glasgow?</h2>

    <div className="atomic">
      <span className="atomic__lb mono">RESUMO</span>
      <p>A ECG descreve o nível de consciência. Outros escores respondem a perguntas clínicas diferentes e devem ser usados apenas quando o cenário exigir aquela estratificação específica.</p>
    </div>

    <dl className="rel">
      {scales.map((scale) => (
        <div className="rel__it" key={scale.name}>
          <dt className="rel__nm">
            {scale.href ? <a href={scale.href}>{scale.name} ↗</a> : scale.name}
          </dt>
          <dd className="rel__ds">
            {scale.description}
            <span className="rel__cx">Contexto Glasgow: {scale.context}</span>
          </dd>
        </div>
      ))}
    </dl>
  </section>
);

export default RelatedScales;
